/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import jsCookie from 'js-cookie';
import { HEADERS } from '../../constants';
import { memoizeWithToken, memoizeWithTokenAndParams } from '../utils/memoizeUtils';

/* istanbul ignore file */
export function save({ data }) {
  const otpToken = jsCookie.get(HEADERS.X_CM_PASSCODE);
  const nextCMPasscode = jsCookie.get(HEADERS.X_NEXTCM_PASSCODE);
  const commonHeaders = axios.defaults.headers.common;
  if (otpToken) commonHeaders[HEADERS.X_CM_PASSCODE] = otpToken;
  if (nextCMPasscode) commonHeaders[HEADERS.X_NEXTCM_PASSCODE] = nextCMPasscode;
  return from(axios.post('payments/initiateSMBPayment', data)).pipe(
    map(({ data }) => {
      delete axios.defaults.headers.common[HEADERS.X_CM_PASSCODE];
      delete axios.defaults.headers.common[HEADERS.X_NEXTCM_PASSCODE];
      return data;
    })
  );
}

export function getWireApproval(payload) {
  return from(axios.post('payments/getWireApproval', payload)).pipe(map(({ data }) => data));
}

export function getPayment(paymentInformation) {
  return from(
    axios.post('payments/simplifiedPayment/getSmallBusinessPayment', paymentInformation)
  ).pipe(map(({ data }) => data));
}

export function getPaymentInformation(paymentInformation) {
  return from(axios.post('payments/simplifiedPayment/retrieveACHOrWire', paymentInformation)).pipe(
    map(({ data }) => data)
  );
}

export function getEntities(postData) {
  return from(axios.post('payments/simplifiedPayment/getAchCompanies', postData)).pipe(
    map(({ data }) => data)
  );
}

// Removing memoization so new users will be immediately available.
export const getPayees = (payload) =>
  from(axios.post('payments/contact/getApprovedPayees', payload)).pipe(
    map(({ data: { data } }) => data)
  );

export const getApprovedEmployeePayees$ = (payload) =>
  from(axios.post('payments/contact/getApprovedPayees', { ...payload, action: 'EMPLOYEE' })).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );

export const getPayeeDetails = memoizeWithTokenAndParams(({ id }) =>
  memoizeWithToken(() =>
    from(axios.post('/payments/getPayeeDetails', { id })).pipe(map(({ data: { data } }) => data))
  )
);

export const viewContact = (payload) =>
  from(axios.post('payments/contact/getPayeeDetail', payload)).pipe(
    map(({ data: { data } }) => data)
  );

export const getDates = memoizeWithTokenAndParams((postData) =>
  from(axios.post('/payments/simplifiedPayment/getCalendar', postData)).pipe(
    map(({ data: { data } }) => data)
  )
);
